import { RECORD_TYPE_DOCUMENT } from '@constants/annotations'

import PartnersRecordsBase from './PartnersRecordsBase'

const PartnersDocuments = () => {
    
    return (
        
        <div className="PartnersDocuments mx-4">
            
            <PartnersRecordsBase
                title="Documents"
                recordType={RECORD_TYPE_DOCUMENT} />
        
        </div>
        
    )
    
}

export default PartnersDocuments
